import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom'; 
import { toast } from 'react-toastify';

const ManageCoHost = () => {
    const { listingId } = useParams();
    const [coHost, setCoHost] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedHost, setSelectedHost] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);

    const fetchCoHost = async () => {
        const hostData = getItemFromLocalStorage('hostProfile');
        let formData = new FormData();
        formData.append('token', hostData.host_access_token);
        formData.append('listing_id', listingId);

        try {
            const response = await axios({
                method: 'post',
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                url: `${params.baseURL}${params.endpoints.coHostList}`,
                data: formData
            });
        
            if (response.data.items && Array.isArray(response.data.items)) {
                setCoHost(response.data.items);
                setLoading(false);
            } else {
                setError('An error occurred while fetching data.');
            }
        } catch (err) {
            setError(err);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCoHost();
    }, []);

    const handleDelete = (hostId) => {
        setSelectedHost(hostId);
        setShowConfirm(true);
    };

    const confirmDelete = async () => {
        const hostData = getItemFromLocalStorage('hostProfile');
        let formData = new FormData();
        formData.append('token', hostData.host_access_token);
        formData.append('listing_id', listingId);
        formData.append('host_id', selectedHost);
    
        try {
          const response = await axios({
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            url: `${params.baseURL}${params.endpoints.deleteCoHost}`,
            data: formData
          });
    
          if (response.data.status === 'deleted') {
            toast.success('Co-host deleted successfully.');
            fetchCoHost();
          } else {
            toast.error('Failed to delete co-host.');
          }
        } catch (err) {
          toast.error('An error occurred while deleting.');
        } finally {
          setShowConfirm(false);
          setSelectedHost(null);
        }
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Manage Co-Host</title>
                <meta name="description" content="" />
            </Helmet>
            <div className='row'>    
                <div className='col-md-4 listing-img-box'>
                    <div>
                        <img src={'/assets/img/banners/co_host_banner.webp'} alt="Listing Image" className="listing-image" />
                    </div>
                </div>
                <div className='col-md-8 offset-md-4'>
                    <div className='ws-cl-header'>
                        <div>
                            <h4 className='ws-title'>Manage Co-Host</h4>
                        </div>
                    </div>

                    <div className='advd-btn'>
                        <a href={`/create-co-host/${listingId}`}>Add new co-host</a>
                    </div>

                    {coHost.length > 0 ? (
                        <div className='row'>
                            {coHost.map((list) => (
                                <div className='col-md-6 lb mb-3' key={list.host_id}>
                                    <div class="mcht-section">
                                        <div className='mcht-box' style={{marginBottom:'10px'}}>
                                        <div>
                                                <img src={list.host_logo || '/assets/img/host_default_image.png'} class="img-fluid mcht-img" alt="" />
                                        </div> 
                                        <span className='separation'></span>
                                        <div className='bd-guest-data' style={{width:'55%', height:'150px', alignContent:'center'}}>
                                            <div className='cat-pointer'>
                                                <img src={'/assets/img/icons/co_host_name.svg'} alt="Profile" className="mchd-icon" />
                                                <span>{list.host_name} {list.host_midname} {list.host_lastname}</span>
                                            </div>
                                            <div className='cat-pointer'>
                                                <img src={'/assets/img/icons/co_host_number.svg'} alt="Profile" className="mchd-icon" />
                                                <span>{list.host_contact_number}</span>
                                            </div>
                                            <div className='cat-pointer'>
                                                <img src={'/assets/img/icons/co_host_email.svg'} alt="Profile" className="mchd-icon" />
                                                <span>{list.host_contact_email}</span>
                                            </div>
                                            <div className='cat-pointer'>
                                                <img src={'/assets/img/icons/co_host_rating.svg'} alt="Profile" className="mchd-icon" />
                                                <span style={{color:'#a6a6a6'}}>
                                                    {Array.from({ length: 5 }).map((_, index) => {
                                                        const rating = list.host_rating;
                                                        const fullStars = Math.floor(rating);
                                                        const hasHalfStar = rating - fullStars >= 0.25 && rating - fullStars < 0.75;

                                                        if (index < fullStars) {
                                                            return <i key={index} className="fas fa-star"></i>;
                                                        } else if (index === fullStars && hasHalfStar) {
                                                            return <i key={index} className="fas fa-star-half-alt"></i>;
                                                        } else {
                                                            return <i key={index} className="far fa-star"></i>;
                                                        }
                                                    })}
                                                </span>
                                            </div>
                                        </div>
                                        </div>
                                        <hr/>
                                        <div className='mcht-btn-box'>
                                            <a href={`/update-co-host/${listingId}/${list.host_id}`} className='btn btn-blank mcht-btn'>Edit</a>
                                            <button className='btn-reject mcht-btn' onClick={() => handleDelete(list.host_id)}>Delete</button>
                                        </div>
                                        <div className='mcht-btn-box mt-3'>
                                            <a href={`/co-host/personal-information/${list.host_id}`} className='btn btn-blank mcht-btn'>Update Spotlight</a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="empty-chat-section ems">
                            <img src={'/assets/img/placeholder/no_cohost.svg'} className='empty-image img-fluid' alt='' />
                        </div>
                    )}
                </div>

            </div>

            {showConfirm && (
                <div className="confirmation-popup-overlay">
                    <div className="confirmation-popup">
                        <p>Are you sure you want to delete this co-host?</p>
                        <div className="popup-actions">
                            <button className="btn btn-danger me-2" onClick={confirmDelete}>Yes, Delete</button>
                            <button className="btn btn-secondary" onClick={() => setShowConfirm(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default ManageCoHost;
